import { ArrowUpRight, CalendarDays } from "lucide-react";
import { useInquiry } from "./Inquiry";
import { useSiteSettings } from "../SiteSettings";
import { Reveal } from "./Motion";

export function InquiryButton({ label = "Start a project", testid = "cta-inquiry-button", className = "primary-button" }) {
  const openInquiry = useInquiry();
  return (
    <button className={className} onClick={openInquiry} data-testid={testid}>
      {label} <ArrowUpRight size={17} />
    </button>
  );
}

export function BookingButton({ testid = "cta-booking-button" }) {
  const openInquiry = useInquiry();
  const { booking_url } = useSiteSettings();
  if (booking_url) {
    return (
      <a className="outline-button" href={booking_url} target="_blank" rel="noreferrer" data-testid={testid}>
        <CalendarDays size={16} /> Book a discovery call
      </a>
    );
  }
  return (
    <button
      className="outline-button"
      onClick={openInquiry}
      data-testid={testid}
      title="Our calendar link is on its way — leave a brief and we'll schedule a call"
    >
      <CalendarDays size={16} /> Book a discovery call
    </button>
  );
}

export function CtaBand({ testid = "cta-band" }) {
  return (
    <section className="cta-band section-pad" data-testid={testid}>
      <Reveal>
        <p className="eyebrow">Have a good one?</p>
        <h2>
          Let&apos;s make
          <br />
          <em>something real.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="contact-actions">
          <InquiryButton testid={`${testid}-inquiry-button`} />
          <BookingButton testid={`${testid}-booking-button`} />
        </div>
      </Reveal>
    </section>
  );
}
